import { AppEnvironment, BASE_ENVIRONMENT } from './environment.base'

export const environment: AppEnvironment = {
    ...BASE_ENVIRONMENT,
    production: true,
}
